// Global chat bus — used by any component to open the LiveChat with a pre-filled draft.
// The LiveChat component (WhatsAppFloat) listens for this event.
export const CHAT_OPEN_EVENT = "locrnc:open-chat";

/**
 * Open the chat panel and pre-fill its draft with a message.
 * If the visitor has no session yet, the message is queued and shown as a preview
 * on the registration form; after they fill their name/phone, the input is pre-filled.
 */
export const openChatWith = (text = "") => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(CHAT_OPEN_EVENT, { detail: { text } }));
};
